import React from "react";
import { Helmet } from "react-helmet";
import Page from "src/components/Page";
import View from "./view";

function index(props) {
  localStorage.removeItem("@storeAuctionLot");
  const search = window.location.search;
  const params = new URLSearchParams(search); 
  const data = params.get('data');


  return (
    <>
    <Helmet>
    <meta itemprop="name" content="Leon Gallery Main Location | Philippine Art Gallery in Manila" />
<meta property="og:title" content="Leon Gallery Main Location | Philippine Art Gallery in Manila" />
<meta name="twitter:title" content="Leon Gallery Main Location | Philippine Art Gallery in Manila" />
<meta itemprop="description" content="Visit the main location of Leon Gallery in Manila, home to the finest collection of Philippine art. Explore our exhibitions, auctions, and exclusive collections of Filipino masterpieces." /> 
<meta property="og:description" content="Visit the main location of Leon Gallery in Manila, home to the finest collection of Philippine art. Explore our exhibitions, auctions, and exclusive collections of Filipino masterpieces." />  
<meta name="twitter:description" content="Visit the main location of Leon Gallery in Manila, home to the finest collection of Philippine art. Explore our exhibitions, auctions, and exclusive collections of Filipino masterpieces." />
<meta itemprop="image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" /> 
<meta property="og:image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" />
<meta name="twitter:image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" /> 
    </Helmet>
    <Page title="Main Location Leon Gallery | Leon Gallery Premier Art Auction House in the Philippines">
     <View param={data}/>
    </Page>
    </>
  );
}

export default index;
